module.exports = __webpack_public_path__ + "img/shakira.0250a528.jpg";